export var QuizItemDirection;

(function (QuizItemDirection) {
  QuizItemDirection["row"] = "row";
  QuizItemDirection["column"] = "column";
})(QuizItemDirection || (QuizItemDirection = {}));

export var QuizItemFeedbackDisplayPolicy;

(function (QuizItemFeedbackDisplayPolicy) {
  QuizItemFeedbackDisplayPolicy["onQuizItem"] = "DisplayFeedbackOnQuizItem";
  QuizItemFeedbackDisplayPolicy["onAllOptions"] = "DisplayFeedbackOnAllOptions";
})(QuizItemFeedbackDisplayPolicy || (QuizItemFeedbackDisplayPolicy = {}));